<ng-container *ngIf="isLoaded">
  <ng-content></ng-content>
</ng-container>
